module.exports = __webpack_public_path__ + "static/media/hourglass-512.5987cc6e.webp";